import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

/**
 * @Description this page String Library's Length Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function ConvertNumber({ action, variables, setOpenVariable, variableRender }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.STRING.';

    return (
        <div>
            <div className="form-element">
                {t(label + 'SOURCESTRING')}
                <TextInput action={action} inputName="sourceString" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired={true} fieldType="string" displayName={t(label + 'SOURCESTRING')} />
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    variableRender={variableRender} isRequired={true} filter="number" />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'number' })}</em></small>
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.STRING.ROUND-NUMBER')}
                <TextInput
                    action={action}
                    inputName="round"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                />
            </div>
        </div>
    )
}

